// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__pE7l0","tagSmall":"Tag_tagSmall__bUhwA","tagSuccess":"Tag_tagSuccess__svd+1"};